import styles from '../account.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { SectionContainer, Input, Button, PageContainer, PageHeader, IconProducts } from '@touche-lts/panel-ui/dist'
import { IconEdit, IconAccountAlt, IconSex, IconPhone, IconPassword, IconCurrencyAlt, IconCalendarAlt  } from 'assets/icons'
import { useEffect, useState } from 'react'
import { useRootStore } from 'mobx-stores/store-provider'
import { DropImages } from "components"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const AccountDetailsComponent = (props) => {
    const {
        accountStore: {
            getUserById,
            setAccountStoreProps,
            accountDetails,
            updateUser,
            passwordChange,
            newPasswordChange,
            repeatNewPasswordChange,
            userPassword,
            newUserPassword,
            repeatNewUserPassword,
            accountLangPreferenceSelected,
            accountLangPreferenceOptions,
            accountCurrencyPreferenceSelected,
            accountCurrencyPreferenceOptions,
            setLangPreference,
            setCurrencyPreference,
        },
        generalStore: {
            showError
        },
        viewStorePageStore: {
            uploadProfileImage
        }
    } = useRootStore();

    const userDetailsId = JSON.parse(localStorage.getItem('userDetails'))?.id;

    const [editModeSection, setEditModeSection] = useState<boolean>(false);
    const [editPassword, setEditPassword] = useState<boolean>(false);

    const onSaveClick = (editPassword?: boolean): void => {
        if (editPassword) {
            if(newUserPassword === repeatNewUserPassword) {
                updateUser(userDetailsId, true)
            } else {
                showError("Passwords do not match")
            }
        } else {
        updateUser(userDetailsId)
        }
        setEditModeSection(false)
        setEditPassword(false)
    }

    const onUploadImage = () => {
        uploadProfileImage(userDetailsId)
    }

    const isFilled = (value) => {
        if (value) return styles.primary;
        return styles.white;
    }

    useEffect(() => {
        if (userDetailsId) {
            getUserById(userDetailsId)
        }
    }, [getUserById, userDetailsId])


    return (
        <PageContainer className={cl('container', styles.scrollable)} style={{ marginTop: 80, overflowX: 'hidden', width : "100%",}}>
            <PageHeader
                navSegments={[
                    {
                        icon: IconProducts,
                        label: 'Account details',
                    }
                ]}
                buttons={[
                    {
                        preset: 'primary',
                        disabled: false,
                        onClick: () => onSaveClick(),
                        children: 'Save',
                        className: styles.submitBtn
                    }
                ]}
                style={{ position: 'static', marginTop: 'auto' }}
                colorPreset='dark'
            />
            <SectionContainer colorPreset='dark' extraPaddingBottom>
                <div className="d-flex justify-content-end">
                    {editModeSection && (
                        <div className={styles.headingButtonsEditContainer}>
                            <Button
                                preset='secondary'
                                colorPreset='dark'
                                onClick={() => setEditModeSection(false)}
                            >
                                Cancel
                            </Button>
                            <Button preset='primary' onClick={() => onSaveClick()}>
                                Save
                            </Button>
                        </div>
                    )}
                </div>

                <div className="row pt-4">
                    <div className="col-lg-3">

                    <div className={styles.imageContainer}>
                            <img className={styles.imageUserDetails} src={accountDetails?.imageUrl && accountDetails?.imageUrl} alt="" />

                            <div className={styles.uploadImage}>
                                <div>
                                <DropImages
                                    onFileDropped={onUploadImage}
                                    className={styles.dropImages}
                                />
                                </div>
                            </div>
                    </div>

                    </div>
                    <div className="col-lg-9">
                        <h4 className="d-flex h3">{accountDetails?.emailAddress}</h4>
                        <div className="row pt-3">
                            <div className="col-lg-6 my-1">

                            <div className={styles.inputIcon}>
                             <span>
                                <IconAccountAlt fill={isFilled(accountDetails?.firstName)} width={32} height={28} />
                             </span>
                             <Input
                                    colorPreset='dark'
                                    placeholder='First name'
                                    value={accountDetails?.firstName}
                                    className={cl(styles.input_have_icon, styles.name)}
                                    onChange={firstName => setAccountStoreProps({ firstName })}
                                />
                             </div>

                            </div>
                            <div className="col-lg-6 my-1">
                            <div className={styles.inputIcon}>
                             <span>
                                <IconAccountAlt fill={isFilled(accountDetails?.lastName)} width={32} height={28} />
                             </span>
                                <Input
                                    colorPreset='dark'
                                    placeholder='Last name'
                                    value={accountDetails?.lastName}
                                    className={styles.input_have_icon}
                                    onChange={lastName => setAccountStoreProps({ lastName })}
                                />
                                </div>
                            </div>
                        </div>
                        <div className="row pt-3">
                            <div className="col-lg-4 my-1">

                        <div className={styles.inputIcon}>
                             <span>
                                <IconCalendarAlt fill={isFilled(accountDetails?.dateOfBirth)} width={32} height={28} />
                             </span>
                               
                                <DatePicker
                                 selected={accountDetails?.dateOfBirth && new Date(accountDetails?.dateOfBirth)}
                                 onChange={dateOfBirth => setAccountStoreProps({ dateOfBirth })}
                                 dateFormat='dd/MM/yyyy'
                                 placeholderText='Date of birth'
                                 className={cl(styles.input_have_icon, styles.datePicker)}
                                  />
                         </div>
                            </div>
                            <div className="col-lg-4 my-1">
                            <div className={styles.inputIcon}>
                                <span>
                                    <IconSex fill={isFilled(accountDetails?.sex)} width={32} height={28} />
                                </span>
                            <div className={styles.selectContainer}>
                              <select 
                              value={accountDetails?.sex}
                              onChange={e => setAccountStoreProps({ sex: e.target.value })}
                                style={{paddingLeft: 50}}>
                                        <option style={{background:'#333333'}} value='Male'>Male</option>
                                        <option style={{background:'#333333'}} value='Female'>Female</option>
                                  </select>
                                 </div>
                              </div>
                             </div>
                            <div className="col-lg-4 my-1">
                            <div className={styles.inputIcon}>
                                <span>
                                    <IconPhone fill={isFilled(accountDetails?.phoneNumber)} width={32} height={28} />
                                </span>
                                <Input
                                    colorPreset='dark'
                                    placeholder='Phone Number'
                                    value={accountDetails?.phoneNumber}
                                    className={styles.input_have_icon}
                                    onChange={phoneNumber => setAccountStoreProps({ phoneNumber })}
                                    type="number"
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SectionContainer>
            <SectionContainer className="mt-4" colorPreset='dark' extraPaddingBottom>
                <div className="d-flex justify-content-end">
                    {!editPassword && (
                        <Button preset='icon' onClick={() => setEditPassword(true)}>
                            <IconEdit fill={styles.white} />
                        </Button>
                    )}
                </div>

                {!editPassword && (
                    <h2 className={styles.changePassword}>Change password</h2>
                )}

                {editPassword && (
                    <div className="row mt-2">
                            <div className="col-lg-4 my-1">
                            <div className={styles.inputIcon}>
                                <span>
                                    <IconPassword fill={isFilled(userPassword)} width={32} height={28} />
                                </span>
                                <Input
                                    colorPreset='dark'
                                    placeholder='Old password'
                                    value={userPassword}
                                    type="password"
                                    className={styles.input_have_icon}
                                    onChange={password => passwordChange(password)}
                                />
                                </div>
                        </div>
                            <div className="col-lg-4 my-1">
                            <div className={styles.inputIcon}>
                                <span>
                                    <IconPassword fill={isFilled(newUserPassword)} width={32} height={28} />
                                </span>
                                <Input
                                    colorPreset='dark'
                                    placeholder='New password'
                                    value={newUserPassword}
                                    type="password"
                                    className={styles.input_have_icon}
                                    onChange={newPassword => newPasswordChange(newPassword)}
                                />
                                </div>
                        </div>

                        <div className="col-lg-4 my-1">
                        <div className={styles.inputIcon}>
                                <span>
                                    <IconPassword fill={isFilled(repeatNewUserPassword)} width={32} height={28} />
                                </span>
                                    <Input
                                    colorPreset='dark'
                                    placeholder='Repeat password'
                                    value={repeatNewUserPassword}
                                    type="password"
                                    className={styles.input_have_icon}
                                    onChange={repeatNewUserPassword => repeatNewPasswordChange(repeatNewUserPassword)}
                                    />
                                    </div>
                        </div>
                    </div>
                )}
            <div className="row mt-4">
                {editPassword && (
                        <div className={styles.headingButtonsEditContainer}>
                            <Button
                                preset='secondary'
                                colorPreset='dark'
                                onClick={() => setEditPassword(false)}
                                className={styles.closeBtn}
                            >
                                Cancel
                            </Button>
                            <Button preset='primary' 
                                    onClick={() => onSaveClick(true)}
                                    className={styles.submitBtn}
                                    >
                                Save
                            </Button>
                        </div>
                    )}
                </div>
            </SectionContainer>
            <SectionContainer className="mt-4" colorPreset='dark' extraPaddingBottom>
                <h2 className={styles.changePassword}>Region preferences</h2>
                        <div className="row pt-4">
                            <div className="col-lg-4">

                            <div className={styles.selectContainer}> 
                              <select 
                                value={accountLangPreferenceSelected}
                                onChange={lang =>
                                setLangPreference((lang as any).target.value)}>
                                {accountLangPreferenceOptions.map(opt => {
                                    return(
                                        <option 
                                        key={opt.value}
                                        value={opt.value}
                                        style={{background:'#333333'}} 
                                        >{opt.label}</option>
                                        )})}
                              </select>
                            </div>

                            </div>
                            <div className="col-lg-4">
                            <div className={styles.inputIcon}>
                                <span>
                                    <IconCurrencyAlt fill={styles.primary} width={32} height={28} />
                                </span>
                            <div className={styles.selectContainer}>
                              <select 
                                style={{paddingLeft: 50}}
                                value={accountCurrencyPreferenceSelected}
                                onChange={currency =>
                                setCurrencyPreference((currency as any).target.value)}>
                                {accountCurrencyPreferenceOptions.map(opt => {
                                    return(
                                        <option 
                                        key={opt.value}
                                        value={opt.value}
                                        style={{background:'#333333'}} 
                                        >{opt.label}</option>
                                        )})}
                                  </select>
                              </div>
                              </div>
                            </div>
                        </div>
            </SectionContainer>
        </PageContainer>
    )
},

    AccountDetails = observer(AccountDetailsComponent)
export { AccountDetails }
